import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=6d7c5558&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=ts&"
export * from "./slider.vue?vue&type=script&lang=ts&"
import style0 from "./slider.vue?vue&type=style&index=0&id=6d7c5558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7c5558",
  null
  
)

export default component.exports